export const conversationSendMessageMutationDefinition = {
  url: '/api/messaging/conversation_messages.json',
  method: 'POST'
};

export const conversationCreateMutationDefinition = {
  url: '/api/messaging/conversations.json',
  method: 'POST'
};
